<header class="c-cover c-cover--reversed t-accent" id="inicio">

  <div class="c-cover__image"></div>

  <span class="c-cover__title-qualifier">
    Redação Nota 1000
  </span>

  <h1 class="c-cover__main-title omega">
    Quer aumentar o desempenho da sua escola e dos seus alunos?
  </h1>

  <div class="c-cover__controls">
    <button matRipple
            [routerLink]="['.']"
            fragment="como-funciona"
            id="btn-topm-entenda-escola"
            class="c-cover__button c-button c-button--large c-button--solid-reversed">
      Veja como funciona

      <fa-icon class="u-margin-left-small" [icon]="['fas', 'arrow-alt-circle-down']"></fa-icon>
    </button>
  </div>

</header>


<section class="c-home-section c-hub-grid t-primary">

  <h2 class="c-home-section__main-title">
    A melhor plataforma de avaliação de redações e desenvolvimento da escrita do Brasil
  </h2>

  <div class="c-home-section__intro">
    <p class="gamma">
      <strong>Redação Nota 1000</strong> é a primeira ferramenta a oferecer
      correção de redações 100% online, que une tecnologia de ponta e um time
      dedicado de corretores especialistas em redação e na língua portuguesa.
    </p>
  </div>


  <div class="c-hub-grid-item c-hub-grid-item--first">
    <h3 class="c-hub-grid-item__title">
      <span class="c-hub-grid-item__number">1</span>
    </h3>
  </div>

  <p class="c-hub-grid-item__content">
      O professor seleciona o tema da redação dentre as opções predefinidas
      ou personalizadas e proa as tarefas para a turma.
  </p>


  <div class="c-hub-grid-item c-hub-grid-item--second">
    <h3 class="c-hub-grid-item__title">
      <span class="c-hub-grid-item__number">2</span>
    </h3>
  </div>

  <p class="c-hub-grid-item__content">
    Os alunos digitam a redação na plataforma ou enviam seus textos manuscritos
    como imagem (fotografia ou digitalização).
  </p>


  <div class="c-hub-grid-item c-hub-grid-item--third">
    <h3 class="c-hub-grid-item__title">
      <span class="c-hub-grid-item__number">3</span>
    </h3>
  </div>

  <p class="c-hub-grid-item__content">
    Com o envio das redações, corretores selecionados entram em ação para fazer
    uma avaliação online completa e detalhada.
  </p>


  <div class="c-hub-grid-item c-hub-grid-item--fourth">
    <h3 class="c-hub-grid-item__title">
      <span class="c-hub-grid-item__number">4</span>
    </h3>
  </div>

  <p class="c-hub-grid-item__content">
    Na plataforma, os professores podem acompanhar a produção dos alunos,
    comparar as avaliações realizadas e exportar os resultados.
  </p>

  <div class="c-hub-grid__image">
    <img redLightbox
         imageUrl="assets/images/laudo-completo--full.png"
         src="assets/images/laudo-completo.png"
         alt="Exemplo de laudo / folha de correção de uma redação"
         id="click-laudoimg">
  </div>

</section>

<section class="c-home-section c-tutorials" id="como-funciona">

  <h2 class="c-home-section__main-title c-tutorials__main-title">
    Tutoriais para apoio
  </h2>

  <div class="c-tutorials__grid">

    <ng-container *ngFor="let tutorial of tutorials">
      <ng-container *ngIf="!(isHidden && (tutorial.label === 'Cadastro de alunos' || tutorial.label === 'Cadastro de professores e equipe'))">
        <div *ngIf="tutorial.video || tutorial.files?.length > 0"
            class="c-tutorials__item">

          <h3 class="c-tutorials__title">{{ tutorial.label }}</h3>

          <ng-container *ngIf="tutorial.video as video">
            <section [ngSwitch]="video.provider"
                    class="c-tutorials__video">

              <ng-container *ngSwitchCase="'YOUTUBE'">
                <iframe class="c-tutorials__video-frame"
                        [src]="'https://www.youtube.com/embed/' + video.id | safe:'resourceUrl'"
                        allowfullscreen
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                </iframe>
              </ng-container>

              <ng-container *ngSwitchCase="'VIMEO'">
                <iframe class="c-tutorials__video-frame"
                        [src]="'https://player.vimeo.com/video/' + video.id | safe:'resourceUrl'"
                        allowfullscreen
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                </iframe>
              </ng-container>

            </section>
          </ng-container>

          <section *ngIf="tutorial.files?.length > 0"
                  class="c-tutorials__files">

            <a *ngFor="let file of tutorial.files"
              class="c-button c-button--small c-button--outline c-tutorials__files-button"
              target="_blank"
              [href]="file.url"
              [download]="file.title + '.pdf'">

              <fa-icon [icon]="[ 'fas', 'file-pdf' ]" class="u-margin-right-tiny"></fa-icon>
              {{ file.title }}
            </a>
          </section>

        </div>
      </ng-container>
    </ng-container>
  </div>

</section>

